import React from 'react';
import styles from './styles.css.js';

var TermsAndConditions = function TermsAndConditions() {
  return React.createElement("p", {
    className: styles.legal
  }, "By clicking Submit you agree to the\xA0", React.createElement("a", {
    href: "https://www.curated.com/legal/terms-conditions",
    target: "_blank",
    className: styles.link
  }, "Terms of Use"), "\xA0and\xA0", React.createElement("a", {
    href: "https://www.curated.com/legal/privacy-policy",
    target: "_blank",
    className: styles.link
  }, "Privacy Policy"));
};

export default TermsAndConditions;
//# sourceMappingURL=index.js.map
